$(function () {
	APP.init();
	moveSubscribeForm();
	// init
	autoGenerateCreateFullPages();

	homeBrandInit();
	lozadInit();
	fancyboxInit();

	accordionInit();
	tabsletControlInit();

	filterInit();
	formProductPopup();
	$('.full-content table').each(function () {
		$(this).wrap('<div class="table-responsive"></div>')
	});
	if (widthWindow >= 1280) {
		$('.filter-group:not(.show) .filter-head .filter-icon-toggle').trigger('click');
	}
	if($('#brand-scroll').length>0){
		$('html, body').animate({
			scrollTop: $('#brand-scroll').offset().top - 100
		}, 1000);
	}

	toggleShowHidePassword();
	homeProductSliderTab();

});

$(window).on('scroll', function () {
	APP.fixed();
});

// variable
var header = $("header"),
	body = $("body"),
	backdrop = $(".backdrop"),
	backToTop = $(".back-to-top"),
	buttonMenu = $("#buttonMenu"),
	buttonSearch = $(".button-search"),
	buttonWishlist = $(".button-wishlist"),
	mobileWrap = $(".mobile-wrap"),
	heightHeader = $("header").height(),
	heightWindow = $(window).height(),
	widthWindow = $(window).width(),
	outerHeightWindow = $(window).outerHeight();

// toggleText
$.fn.extend({
	toggleText: function (a, b) {
		return this.text(this.text() == b ? a : b);
	},
});

var APP = {
	fixed: () => {
		// header
		$(window).scrollTop() > heightHeader
			? header.addClass("active")
			: header.removeClass("active");
		$(window).scrollTop() > (outerHeightWindow - heightHeader)
			? backToTop.addClass("active")
			: backToTop.removeClass("active");
	},
	backdrop: () => {
		backdrop.on('click', function () {
			$(this).removeClass('open');
			$("#buttonMenu").removeClass('open'); // remove button menu header
			$(".search-wrap").removeClass('open'); // remove search header
			mobileWrap.removeClass('open'); // remove menu header
		});
	},
	backToTop: () => {
		backToTop.on('click', function () {
			$('html, body').animate({ scrollTop: 0 }, 500);
		})
	},
	mapping: () => {
		const mainMenuLeft = $("header .header-left .navbar-nav").mapping({
			mobileWrapper: ".mobile-wrap .navbar-nav-list",
			mobileMethod: "prependTo",
			desktopWrapper: "header .header-left",
			desktopMethod: "prependTo",
			breakpoint: 1279.98,
		});
		const mainMenuRight = $("header .header-right .navbar-nav").mapping({
			mobileWrapper: ".mobile-wrap .navbar-nav-list",
			mobileMethod: "appendTo",
			desktopWrapper: "header .header-right",
			desktopMethod: "prependTo",
			breakpoint: 1279.98,
		});
		const buttonSearch = $("header .header-right .button-search").mapping({
			mobileWrapper: "header .header-left",
			mobileMethod: "appendTo",
			desktopWrapper: "header .header-right .navbar-nav",
			desktopMethod: "insertAfter",
			breakpoint: 1279.98,
		});
		const buttonWishlist = $("header .header-right .button-wishlist").mapping({
			mobileWrapper: "header .header-left",
			mobileMethod: "appendTo",
			desktopWrapper: "header .header-right .button-search",
			desktopMethod: "insertAfter",
			breakpoint: 1279.98,
		});
		const buttonAccount = $("header .header-right .button-account").mapping({
			mobileWrapper: ".mobile-wrap .navbar-nav-list",
			mobileMethod: "appendTo",
			desktopWrapper: "header .header-right .button-language",
			desktopMethod: "insertBefore",
			breakpoint: 1279.98,
		});
	},
	megaBrandMenu: () => {
		var urlBrandLoad = "/Product/Services/BrandService.aspx";
		var dataBrand = { "method": "GetBrands" };
		var settings = {
			"url": urlBrandLoad,
			"method": "POST",
			"timeout": 0,
			"headers": {
				"Content-Type": "application/x-www-form-urlencoded",
			},
			"data": dataBrand
		};

		$.ajax(settings).done(function (response) {
			// $('.mega-dropdown-brand').append(response.data);
			// const defaultBrandImage = $('.brand-image-wrap .brand-image img').data('src');
			// const defaultBrandThumbImage = $('.brand-image-wrap .brand-thumbs img').data('src');
			// mega menu hover
			if (widthWindow >= 1280) {
				$('.mega-dropdown-brand .mega-dropdown .sub-menu > li')
				.on('mouseenter', function () {
					// const dataImageUrl = $(this).data('manufacturer-url');
					// const dataSecondImageUrl = $(this).data('manufacturer-second-url');
					// $('.brand-image-wrap .brand-image img').attr('src', dataImageUrl);
					// $('.brand-image-wrap .brand-thumbs img').attr('src', dataSecondImageUrl);
					$(this).addClass('show-active').siblings().removeClass('show-active');
				})
				.on('mouseleave', function () {
					// $('.brand-image-wrap .brand-image img').attr('src', defaultBrandImage);
					// $('.brand-image-wrap .brand-thumbs img').attr('src', defaultBrandThumbImage);
				});
			}
		});
	},
	megaMenu: () => {
		// toggle menu
		$("#buttonMenu").on("click", function () {
			$(this).toggleClass("open");
			$(".mobile-wrap").toggleClass("open");
			$(".search-wrap").removeClass("open");
			backdrop.toggleClass('open');
		});
		// init icon mega menu
		$(".mobile-wrap .main-menu .has-mega > a").each(function () {
			$(this).after('<i class="fa-light fa-chevron-right mega-toggle-icon"></i>');
			$(this).parent().find('.mega-dropdown').prepend('<i class="fa-light fa-chevron-left mega-back-icon"></i>');
		});
		$(".mobile-wrap .main-menu .has-children > a").each(function () {
			$(this).after('<i class="fa-light fa-chevron-down children-toggle-icon"></i>');
		});
		// toggle mega menu
		$(".mobile-wrap .main-menu .mega-toggle-icon").on("click", function () {
			$(this).next().addClass('active');
		});
		$(".mobile-wrap .main-menu .children-toggle-icon").on("click", function () {
			$(this).toggleClass("active");
			$(this).next().slideToggle();
		});
		$(".mobile-wrap .main-menu .mega-back-icon").on("click", function () {
			$(this).parent().removeClass('active');
		});

		const defaultProductImage = $('.product-image-wrap .img-scale').html();
		// mega menu hover
		if (widthWindow >= 1280) {
			$('.mega-dropdown-product .mega-dropdown li a').on('mouseenter', function () {
				const pathImg = $(this).data('zone-image-url');
				const ImageHTML = `<img src="${pathImg}"></img>`;
				if(pathImg != undefined)
					$('.product-image-wrap .img-scale').html(ImageHTML);
				else
					$('.product-image-wrap .img-scale').html('');
			}).on('mouseleave', function () {
				$('.product-image-wrap .img-scale').html(defaultProductImage);
			});
		}
	},
	toggleLanguage: () => {
		// toggle language
		$(".button-language").on("click", function () {
			$(this).toggleClass("open");
			$(".language-dropdown").toggleClass("open");
			// backdrop.toggleClass('open');
		});
	},
	toggleAccount: () => {
		// toggle account
		$(".button-account").on("click", function () {
			$(this).toggleClass("open");
			$(".account-dropdown").toggleClass("open");
			// backdrop.toggleClass('open');
		});
	},
	toggleSearch: () => {
		// toggle search
		$(".button-search").on("click", function () {
			$(this).toggleClass("open");
			$(".search-wrap").toggleClass("open");
			// backdrop.toggleClass('open');
		});
	},
	toggleCart: () => {
		$(".button-cart").on("click", function () {
			$(".cart-dropdown").toggleClass("show");
		});
		$(".cart-close").on("click", function () {
			$(".cart-dropdown").removeClass("show");
		});
	},
	init: () => {
		APP.backdrop();
		APP.backToTop();
		APP.mapping();
		APP.megaBrandMenu();
		APP.megaMenu();
		APP.toggleLanguage();
		APP.toggleAccount();
		APP.toggleCart();
		APP.toggleSearch();
	}
}

function autoGenerateCreateFullPages() {
	const mediaQuery = "(min-width: 1280px)";
	const mediaQueryList = window.matchMedia(mediaQuery);
	mediaQueryList.addEventListener("change", (event) => {
		console.log(window.innerWidth);
	});

	if (mediaQueryList.matches) {
		console.log("The window is now 1280px or upper");
		const footerHtml = $("footer").html();
		$(".home-contact-section").append(footerHtml);
		const fullPagesSlider = new Swiper(".swiper-full-pages", {
			direction: "vertical",
			slidesPerView: 1,
			mousewheel: true,
			mousewheel: {
				forceToAxis: true,
				thresholdTime: 1200,
			},
			keyboard: {
				enabled: true,
			},
			allowTouchMove: false,
			effect: "creative",
			speed: 1000,
			creativeEffect: {
				prev: {
					shadow: true,
					translate: [0, "-50%", -1],
				},
				next: {
					translate: [0, "100%", 0],
				},
			},
			pagination: {
				el: ".swiper-full-pages > .swiper-pagination",
				clickable: true,
				renderBullet: function (index, className) {
					var titles = $('.section-full-pages');
					return `<span class="${className}"> ${index + 1 < 10 ? `0` + (index + 1) : index + 1
						} <span class="${className}-title">${$(titles[index]).data('fp-title') }</span></span>`;
				},
			},
			on: {
				slideChange: function (active) {
					if (this.realIndex > 0) {
						header.addClass('fullpages-hide')
						// console.log("trigger");
						// var video_id = document.getElementById("myVideo");
						// video_id.currentTime = 0;
					} else {
						header.removeClass('fullpages-hide')
					}
				},
			},
		});
		$(".disable-scroll-parent")
			.on("mouseenter", function () {
				fullPagesSlider.mousewheel.disable();
			})
			.on("mouseleave", function () {
				fullPagesSlider.mousewheel.enable();
			});
	} else {
		console.log("The window is now over 1280px");
	}
}

var homeBannerAutoplay = false;
var homeBannerVideoPlay = {};
if ($('.home-banner-section .swiper-slide video').length > 0){
	homeBannerVideoPlay = {
		init: function () {
			// console.log("Swiper initialized");
			var activeIndex = this.activeIndex;
			var activeSlide = document.getElementsByClassName('swiper-slide')[activeIndex];
			var activeSlideVideo = activeSlide.querySelector('video');

			if (activeSlideVideo) {
				activeSlideVideo.currentTime = 0;
				activeSlideVideo.play();
				activeSlideVideo.addEventListener('ended', function () {
					homeBannerSlider.slideNext();
				});
			} else {
				setTimeout(function () {
					homeBannerSlider.slideNext();
				}, 2000);
			}
		},
		transitionStart: function () {
			// console.log("Transition start");
			var videos = document.querySelectorAll('video');
			Array.prototype.forEach.call(videos, function (video) {
				video.pause();
			});
		},
		transitionEnd: function () {
			// console.log("Transition end");
			var activeIndex = this.activeIndex;
			var activeSlide = document.getElementsByClassName('swiper-slide')[activeIndex];
			var activeSlideVideo = activeSlide.querySelector('video');

			if (activeSlideVideo) {
				activeSlideVideo.currentTime = 0;
				activeSlideVideo.play();
				activeSlideVideo.addEventListener('ended', function () {
					homeBannerSlider.slideNext();
				});
			} else {
				setTimeout(function () {
					homeBannerSlider.slideNext();
				}, 2000);
			}
		},
		slideChange: function () {
			// console.log("Slide change");
			var activeIndex = this.activeIndex;
			var activeSlide = document.getElementsByClassName('swiper-slide')[activeIndex];
			var activeSlideVideo = activeSlide.querySelector('video');
			if (activeSlideVideo) {
				activeSlideVideo.currentTime = 0;
				activeSlideVideo.play();
				activeSlideVideo.addEventListener('ended', function () {
					homeBannerSlider.slideNext();
				});
			}
		},
	}
}
if ($('.home-banner-section .swiper-slide video').length == 0) {
	homeBannerAutoplay = {
		delay: 5000,
		disableOnInteraction: false,
		pauseOnMouseEnter: true,
	}
}

const homeBannerSlider = new Swiper(".home-banner-section .swiper", {
	loop: true,
	autoplay: {
		...homeBannerAutoplay,
	},
	speed: 1000,
	observer: true,
	observeParents: true,
	lazy: {
		loadPrevNext: true,
	},
	navigation: {
		nextEl: ".home-banner-section .button-next",
		prevEl: ".home-banner-section .button-prev",
	},
	pagination: {
		el: ".home-banner-section .swiper-pagination",
		clickable: true,
	},
	keyboard: {
		enabled: true,
		onlyInViewport: false
	},
	runCallbacksOnInit: true,
	on: {
		...homeBannerVideoPlay,
	}
});

const homeBrandSlider = new Swiper(".home-brand-section .swiper", {
	loop: true,
	autoplay: {
		delay: 5000,
		disableOnInteraction: false,
		pauseOnMouseEnter: true,
	},
	speed: 1000,
	observer: true,
	observeParents: true,
	spaceBetween: 30,
	lazy: {
		loadPrevNext: true,
	},
	navigation: {
		nextEl: ".home-brand-section .button-next",
		prevEl: ".home-brand-section .button-prev",
	},
	pagination: {
		el: ".home-brand-section .swiper-pagination",
		clickable: true,
	},
});



// home product tabslet slider
$('.modal-contact').each(function (index) {
	$(this).find('.swiper').addClass('swiper-' + index);
	$(this).find('.button-next').addClass('button-next-' + index);
	$(this).find('.button-prev').addClass('button-prev-' + index);
	$(this).find('.swiper-pagination').addClass('swiper-pagination-' + index);
	const contactModalSlide = new Swiper(".modal-contact .swiper-" + index, {
		speed: 1000,
		spaceBetween: 15,
		observer: true,
		observeParents: true,
		lazy: {
			loadPrevNext: true,
		},
		navigation: {
			nextEl: ".modal-contact .button-next-" + index,
			prevEl: ".modal-contact .button-prev-" + index,
		},
		pagination: {
			el: ".modal-contact .swiper-pagination-" + index,
			clickable: true,
		},
		breakpoints: {
			576: {
				slidesPerView: 2,
			},
			768: {
				slidesPerView: 2,
			},
			1024: {
				slidesPerView: 3,
			},
			1280: {
				slidesPerView: 3,
			},
		},
	});
});

const productDetailThumbsSlider = new Swiper(".product-detail-slider .swiper-thumbs", {
	slidesPerView: 4,
	spaceBetween: 10,
	watchSlidesProgress: true,
	breakpoints: {
		768: {
			slidesPerView: 5,
			spaceBetween: 15,
		},
		1024: {
			slidesPerView: 5,
			spaceBetween: 15,
		},
		1280: {
			slidesPerView: 5,
			spaceBetween: 20,
		},
	},
});

const productDetailTopSlider = new Swiper(".product-detail-slider .swiper-top", {
	spaceBetween: 30,
	thumbs: {
		swiper: productDetailThumbsSlider,
	},
	navigation: {
		nextEl: ".product-detail-slider .button-next",
		prevEl: ".product-detail-slider .button-prev",
	},
	pagination: {
		el: ".product-detail-slider .swiper-pagination",
		clickable: true,
		dynamicBullets: true,
	},
});

// product color slider
$('.color-list').each(function (index) {
	$(this).find('.swiper').addClass('swiper-' + index);
	$(this).find('.button-next').addClass('button-next-' + index);
	$(this).find('.button-prev').addClass('button-prev-' + index);
	$(this).find('.swiper-pagination').addClass('swiper-pagination-' + index);
	const productColorSlider = new Swiper(".color-list .swiper-"+index, {
		speed: 1000,
		slidesPerView: 3,
		spaceBetween: 15,
		observer: true,
		observeParents: true,
		lazy: {
			loadPrevNext: true,
		},
		navigation: {
			nextEl: ".color-list .button-next-"+index,
			prevEl: ".color-list .button-prev-"+index,
		},
		pagination: {
			el: ".color-list .swiper-pagination-"+index,
			clickable: true,
		},
		breakpoints: {
			576: {
				slidesPerView: 4,
				spaceBetween: 20,
			},
			768: {
				slidesPerView: 3,
				spaceBetween: 20,
			},
			1024: {
				slidesPerView: 4,
				spaceBetween: 20,
			},
			1280: {
				slidesPerView: 4,
				spaceBetween: 30,
			},
			1440: {
				slidesPerView: 4,
				spaceBetween: 60,
			},
		},
	});
});

// product related slider
const productRelatedSlider = new Swiper(".product-detail-related-section .swiper", {
	loop: true,
	autoplay: {
		delay: 5000,
		disableOnInteraction: false,
		pauseOnMouseEnter: true,
	},
	speed: 1000,
	spaceBetween: 15,
	observer: true,
	observeParents: true,
	lazy: {
		loadPrevNext: true,
	},
	navigation: {
		nextEl: ".product-detail-related-section .button-next",
		prevEl: ".product-detail-related-section .button-prev",
	},
	pagination: {
		el: ".product-detail-related-section .swiper-pagination",
		clickable: true,
	},
	breakpoints: {
		576: {
			slidesPerView: 2,
			spaceBetween: 20,
		},
		768: {
			slidesPerView: 3,
			spaceBetween: 20,
		},
		1024: {
			slidesPerView: 4,
			spaceBetween: 20,
		},
		1280: {
			slidesPerView: 4,
			spaceBetween: 30,
		},
	},
});

// magazine related slider
const magazineRelatedSlider = new Swiper(".magazine-detail-related-section .swiper", {
	loop: true,
	autoplay: {
		delay: 5000,
		disableOnInteraction: false,
		pauseOnMouseEnter: true,
	},
	speed: 1000,
	spaceBetween: 15,
	observer: true,
	observeParents: true,
	lazy: {
		loadPrevNext: true,
	},
	navigation: {
		nextEl: ".magazine-detail-related-section .button-next",
		prevEl: ".magazine-detail-related-section .button-prev",
	},
	pagination: {
		el: ".magazine-detail-related-section .swiper-pagination",
		clickable: true,
	},
	breakpoints: {
		576: {
			slidesPerView: 2,
			spaceBetween: 20,
		},
		768: {
			slidesPerView: 3,
			spaceBetween: 20,
		},
		1024: {
			slidesPerView: 3,
			spaceBetween: 50,
		},
		1280: {
			slidesPerView: 3,
			spaceBetween: 75,
		},
		1440: {
			slidesPerView: 3,
			spaceBetween: 105,
		},
	},
});

// about outstanding award detail
const aboutYearSlider = new Swiper(".about-history-section .swiper-year", {
	rewind: true,
	watchSlidesProgress: true,
	slideToClickedSlide: true,
	watchSlidesVisibility: true,
	spaceBetween: 10,
	slidesPerView: 3,
	breakpoints: {
		576: {
			slidesPerView: 4,
		},
		768: {
			slidesPerView: 4,
		},
		1024: {
			slidesPerView: 5,
		},
		1280: {
			slidesPerView: 6,
		},
	},
});
const aboutImageSlider = new Swiper(".about-history-section .swiper-image", {
	rewind: true,
	spaceBetween: 10,
	autoHeight: true,
	// effect: "fade",
	// fadeEffect: {
	// 	crossFade: true
	// },
	speed: 1000,
	grabCursor: true,
	effect: "creative",
	creativeEffect: {
		prev: {
			shadow: true,
			translate: ["-20%", 0, -1],
		},
		next: {
			translate: ["100%", 0, 0],
		},
	},
	navigation: {
		nextEl: ".about-history-section .button-next",
		prevEl: ".about-history-section .button-prev",
	},
	thumbs: {
		swiper: aboutYearSlider,
	},
	on: {
		slideChange: function () {
			let activeIndex = this.activeIndex + 1;
			let activeSlide = document.querySelector(`.about-history-section .swiper-year .swiper-slide:nth-child(${activeIndex})`);
			let nextSlide = document.querySelector(`.about-history-section .swiper-year .swiper-slide:nth-child(${activeIndex + 1})`);
			let prevSlide = document.querySelector(`.about-history-section .swiper-year .swiper-slide:nth-child(${activeIndex - 1})`);

			if (nextSlide && !nextSlide.classList.contains('swiper-slide-visible')) {
				this.thumbs.swiper.slideNext()
			} else if (prevSlide && !prevSlide.classList.contains('swiper-slide-visible')) {
				this.thumbs.swiper.slidePrev()
			}

		}
	}
});

const brandSlider = new Swiper(".brand-list-section .swiper", {
	loop: true,
	autoplay: {
		delay: 3000,
		disableOnInteraction: false,
		pauseOnMouseEnter: true,
	},
	spaceBetween: 10,
	autoHeight: true,
	speed: 1000,
	grabCursor: true,
	effect: "creative",
	creativeEffect: {
		prev: {
			shadow: true,
			translate: ["-20%", 0, -1],
		},
		next: {
			translate: ["100%", 0, 0],
		},
	},
	navigation: {
		nextEl: ".brand-list-section .button-next",
		prevEl: ".brand-list-section .button-prev",
	},
});

function homeBrandInit() {
	var urlBrandLoad = "/Product/Services/BrandService.aspx";
	var dataBrand = { "method": "GetZones" };
	var settings = {
		"url": urlBrandLoad,
		"method": "POST",
		"timeout": 0,
		"headers": {
			"Content-Type": "application/x-www-form-urlencoded",
		},
		"data": dataBrand
	};

	$.ajax(settings).done(function (response) {
		// console.log("🚀 ~ file: main.js ~ line 604 ~ response", response.data)
	});
}

// product color slider
$('.download-block-item').each(function (index) {
	$(this).find('.swiper').addClass('swiper-' + index);
	$(this).find('.button-next').addClass('button-next-' + index);
	$(this).find('.button-prev').addClass('button-prev-' + index);
	$(this).find('.swiper-pagination').addClass('swiper-pagination-' + index);
	const downloadSlider = new Swiper(".download-block-item .swiper-"+index, {
		speed: 1000,
		slidesPerView: 1,
		spaceBetween: 15,
		observer: true,
		observeParents: true,
		lazy: {
			loadPrevNext: true,
		},
		navigation: {
			nextEl: ".download-block-item .button-next-"+index,
			prevEl: ".download-block-item .button-prev-"+index,
		},
		pagination: {
			el: ".download-block-item .swiper-pagination-"+index,
			clickable: true,
		},
		breakpoints: {
			576: {
				slidesPerView: 2,
				spaceBetween: 20,
			},
			768: {
				slidesPerView: 3,
				spaceBetween: 20,
			},
			1024: {
				slidesPerView: 4,
				spaceBetween: 20,
			},
			1280: {
				slidesPerView: 4,
				spaceBetween: 30,
			},
		},
	});
});

function lozadInit() {
	// Initialize library to lazy load images
	const observer = lozad('.lozad', {
		threshold: 0.1,
		// enableAutoReload: true,
	});
	observer.observe()
}

function fancyboxInit() {
	Fancybox.bind("[data-fancybox]", {
		showLoading: true,
		preload: true,
		infinite: false,
		parentEl: document.forms[0], // Element containing main structure
		mainClass: "fancybox-wrapper", // Custom class name or multiple space-separated class names for the container
		autoFocus: false,
	});

	Fancybox.bind("a.popup-link", {
		showLoading: true,
		type: "iframe",
		preload: true,
	});

	Fancybox.bind('[data-fancybox="single"]', {
		groupAttr: false,
	});

	$(".btn-close-fancybox").on("click", function () {
		Fancybox.close();
	});

	// disable  drag fancybox in contact
	Fancybox.bind(".contact-page [data-fancybox]", {
		dragToClose: false,
	});
}

function equalHeight(el) {
	var height = 0;
	$(el).each(function () {
		var thisHeight = $(this).height();
		if (thisHeight > height) {
			height = thisHeight;
		}
		setTimeout(() => {
			$(el).height(height)
		}, 100)
	})
}

function checkCookie(cookieName) {
	let mP = getCookie(cookieName);
	$('.home-product .product-item a').on('click', function () {
		var dataMPC = $(this).data('master-plan');
		setCookie("masterPlan", dataMPC, 1);
	});
	if (mP != "") {
		$('.master-plan .main-tabslet').tabslet({
			active: Number(mP)
		});
		setTimeout(() => {
			$(`.site-plan .site-plan-tabs .plan-list li a[data-maphilight="maparea-${mP}"]`).trigger('click');
		}, 500);
	} else {
		$('.master-plan .main-tabslet').tabslet();
	}
}

function countStart(el, num) {
	const options = {
		separator: '.',
		enableScrollSpy: true, // if true -> turn off countUp.start() after first scroll spy check
		scrollSpyDelay: 500, // delay for scroll spy check
		scrollSpyOnce: true,
	};

	let countUp = new CountUp(el, num, options);

	if (!countUp.error) {
		// countUp.start(() => console.log('Complete!'));
	} else {
		console.error(countUp.error);
	}
}

function countUpInit() {
	const elNumber = $(".count-number-current");
	if (elNumber)
		elNumber.each(function (index) {
			let dataCount = $(elNumber[index]).data('count');
			countStart(elNumber[index], dataCount);
		})
}

function accordionInit() {
	$('.accordion_item').on('click', function () {
		$(this)
			.toggleClass('active')
			.siblings().removeClass('active')
		$(this)
			.find('.accordion_header').toggleClass('active')
			.parents('.accordion_item')
			.siblings().find('.accordion_header').removeClass('active')
		$(this)
			.find('.accordion_content').slideToggle()
			.parents('.accordion_item')
			.siblings().find('.accordion_content').slideUp('active')
	});
}

function tabsletControlInit() {
	$('.tabslet-tabs li').on('click', function () {
		$('.caracole-group .caracole-item').eq($(this).index()).addClass('active').siblings().removeClass('active');
	})
}

function filterInit() {
	$('.button-filter').on('click', function () {
		$('.filter-box').toggleClass('open');
		$('.filter-overlay').toggleClass('open');
	});
	$('.filter-overlay').on('click', function () {
		$('.filter-box').removeClass('open');
		$('.filter-overlay').removeClass('open');
	});
	$('.filter-group .filter-head .filter-icon-toggle').on('click', function () {
		$(this).parent().toggleClass('active').next().slideToggle();
	});
	$('.filter-menu .has-children .children-icon-toggle').on('click', function () {
		$(this).next().slideToggle().parent().toggleClass('active').siblings().removeClass('active').find('.children-icon-toggle').next().slideUp();
	});
}

function formProductPopup() {
	const productTitle = $('.product-detail-section h1.product-title').text();
	$('.modal-consulting-information .form-product-title input').val(productTitle).attr('readonly', true).attr('disabled', true);
}

function moveSubscribeForm(){
	$('.subscribe-movehtml').appendTo('footer .newsletter');
}

function homeProductSliderTab(){
	// home product tabslet slider
	$('.home-product-section').each(function(index){
		$(this).find('.swiper').addClass('swiper-' + index);
		$(this).find('.button-prev').addClass('button-prev-' + index);
		$(this).find('.button-next').addClass('button-next-' + index);
		$(this).find('.swiper-pagination').addClass('swiper-pagination-' + index);
		const homeProductSlider = new Swiper(".home-product-section .swiper-"+index, {
			loop: true,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
				pauseOnMouseEnter: true,
			},
			speed: 1000,
			spaceBetween: 15,
			observer: true,
			observeParents: true,
			lazy: {
				loadPrevNext: true,
			},
			navigation: {
				nextEl: ".home-product-section .button-next-"+index,
				prevEl: ".home-product-section .button-prev-"+index,
			},
			pagination: {
				el: ".home-product-section .swiper-pagination-"+index,
				clickable: true,
			},
			breakpoints: {
				576: {
					slidesPerView: 2,
					spaceBetween: 20,
				},
				768: {
					slidesPerView: 2,
					spaceBetween: 20,
				},
				1024: {
					slidesPerView: 3,
					spaceBetween: 20,
				},
				1280: {
					slidesPerView: 3,
					spaceBetween: 30,
				},
			},
		});
	})
	$('.home-product-tab').tabslet()
}

function toggleShowHidePassword(){
	$('.input-pwd-reveal').each(function(){
		let input = $(this).find('input')
		let btnToggle = $(this).find('.reveal-password');
		btnToggle.on('click', function(){
			let checkType = input.attr('type');
			$(this).toggleClass('active')
			if (checkType == 'Password'){
				input.attr('type', 'text')
			}
			else if (checkType == 'text'){
				input.attr('type', 'Password')
			}
		})
	})
}
